import { useCallback, useState } from 'react';

import type { HeaderDialog } from '../types';
import type { HeaderDialogController } from './types';

export default function useHeaderDialog(): HeaderDialogController {
  const [activeDialog, setActiveDialog] = useState<HeaderDialog | null>(null);

  const openDialog = useCallback((dialog: HeaderDialog) => setActiveDialog(dialog), []);
  const closeDialog = useCallback(() => setActiveDialog(null), []);

  return { activeDialog, openDialog, closeDialog };
}
